import React, { Component } from 'react';
import { withApollo } from 'react-apollo';
import { AppContext } from '../../AppProvider';
import { Table as DvExTable } from '@devexpress/dx-react-grid-material-ui';
import {
  withCombinedStyles,
  withComposedEnhancers
} from '../../utils/hocUtils';
import { withNamespaces } from 'react-i18next';
import classnames from 'classnames';
import _isNumber from 'lodash/isNumber';

import Table from '../../components/Global/Table/Table';
import SelectInput from '../../components/Global/Inputs/Select';
import { Link } from 'react-router-dom';
import Breadcrumbs from '@material-ui/lab/Breadcrumbs';

import LayoutStyles from '../../styles/layout';
import TypographyStyles from '../../styles/typography';
import ReportStyles from './Report.styles';

import tableMetadata from './InvoiceBatchesTable.metadata';

import { retrieveCarrierFilterData } from '../../utils/filterDataHelpers';
import * as DataAccess from './InvoiceBatches.data';
// import * as DataAccess from './InvoiceBatches.data.mock';
import { DEFAULT_ROWS_PER_PAGE } from '../../constants/constants';
import DateRangeField from '../../components/Global/Inputs/DateRangeField';

const ALL_OPTION_VALUE = 'all';
export class InvoiceBatches extends Component {
  constructor(props) {
    super(props);

    this.state = {
      rowsSelected: [],
      rowData: [],
      deleting: false,
      loading: true,
      loadingFilters: true,
      error: null,
      errorLoadingFilters: null,
      page: 0,
      filterSelectData: {
        carriers: []
      },
      filters: {
        processedDate: ALL_OPTION_VALUE,
        carrier: ALL_OPTION_VALUE
      },
      rowsPerPage: localStorage.getItem('PropelRowsPerPage')
        ? parseInt(localStorage.getItem('PropelRowsPerPage'), 10)
        : DEFAULT_ROWS_PER_PAGE,
      totalCount: 0,
      offset: 0
    };
  }

  async componentDidMount() {
    await Promise.all([this._loadFilters(), this._loadListData()]);
  }

  _loadFilters = async () => {
    const { client: ApolloClient, t } = this.props;
    const { orgId } = this.context.globalProps.orgInfo;

    const allOption = { title: t('All'), value: ALL_OPTION_VALUE };

    const carriers = await retrieveCarrierFilterData(orgId, ApolloClient);

    const carrierSelectOptions = carriers.map(c => ({
      title: c.name,
      value: c.id
    }));
    this.setState({
      filterSelectData: { carriers: [allOption, ...carrierSelectOptions] }
    });
  };
  _loadListData = async () => {
    const { client: ApolloClient } = this.props;
    const { orgId } = this.context.globalProps.orgInfo;
    const { page, rowsPerPage } = this.state;
    const offset = page * rowsPerPage;

    try {
      const { from, to } = this._processedOnFilterValue(
        this.state.filters.processedDate
      );
      const { results, totalCount } = await DataAccess.retrieveListData(
        orgId,
        this._carrierFilterValue(this.state.filters.carrier),
        from,
        to,
        rowsPerPage,
        offset,
        ApolloClient
      );

      this.setState({
        rowData: results,
        totalCount: _isNumber(totalCount) ? totalCount : this.state.totalCount,
        offset
      });
    } catch (error) {
      this.setState({
        error
      });
    } finally {
      this.setState({
        loading: false
      });
    }
  };
  _carrierFilterValue = stateValue => {
    if (stateValue === ALL_OPTION_VALUE) return null;
    return stateValue;
  };
  _processedOnFilterValue = stateValue => {
    if (stateValue === ALL_OPTION_VALUE) return { from: null, to: null };
    const parts = stateValue.split(' - ');
    if (parts.length > 1) return { from: parts[0], to: parts[1] };
    return { from: stateValue, to: stateValue };
  };

  _changePage = page => {
    this.setState({ page, loading: true }, this._loadListData);
  };

  _changeRowsPerPage = rowsPerPage => {
    localStorage.setItem('PropelRowsPerPage', rowsPerPage);
    this.setState({ rowsPerPage: rowsPerPage, page: 0 });
    const rows = rowsPerPage === 0 ? DEFAULT_ROWS_PER_PAGE : rowsPerPage;
    this.setState(
      { rowsPerPage: rows, page: 0, loading: true },
      this._loadListData
    );
  };

  _handleRowClick = row =>
    this.props.history.push(`/reports/carrier-invoice-batches/${row.id}`);

  _handleSelectRow = rowsSelected => this.setState({ rowsSelected });

  _handleFilter = ({ target: { name, value } }) => {
    this.setState(
      {
        filters: {
          ...this.state.filters,
          [name]: value
        }
      },
      this._loadListData
    );
  };

  render() {
    const { t, classes } = this.props;
    const { error } = this.state;
    return (
      <div>
        <div className={classes.titleRootWrapper}>
          <Breadcrumbs
            separator="›"
            arial-label="Breadcrumb"
            className={classnames(classes.headline5)}
          >
            <Link className={classnames(classes.headline4)} to="/reports">
              {t('Reports')}
            </Link>
            <span>{t('Invoice Batches')}</span>
          </Breadcrumbs>
        </div>
        <div className={classes.filterOptionsWrapper}>
          <SelectInput
            name={'carrier'}
            inputLabel={t('Carrier')}
            options={this.state.filterSelectData.carriers}
            defaultValue={this.state.filters.carrier}
            onChange={this._handleFilter}
          />
          <DateRangeField
            name="processedDate"
            label={t('Processed On')}
            onChange={this._handleFilter}
            value={this.state.filters.processedDate}
          />
        </div>
        <div>
          <Table
            name={t('Invoice Batches')}
            columns={tableMetadata.columns({ t })}
            data={this.state.rowData}
            orderBy="id"
            order={'desc'}
            page={this.state.page}
            rowsPerPage={this.state.rowsPerPage}
            rowComponent={props => (
              <DvExTable.Row
                {...props}
                className={classes.tableRow}
                onClick={() => this._handleRowClick(props.row)}
              />
            )}
            totalCount={this.state.totalCount}
            loading={this.state.loading}
            withDownload={false}
            withColumnChooser={false}
            withSelection={false}
            withServerPaging={true}
            onChangePage={this._changePage}
            onChangePageRowsPerPage={this._changeRowsPerPage}
            dateColumns={tableMetadata.dateColumns}
            dateFormat="MMM D YYYY, h:mm a"
            currencyColumns={tableMetadata.currencyColumns}
            valueIfBlank="--"
            error={error}
          />
        </div>
      </div>
    );
  }
}

const localStyles = () => ({});

InvoiceBatches.contextType = AppContext;
export default withComposedEnhancers(
  InvoiceBatches,
  withNamespaces(),
  withCombinedStyles(
    true,
    TypographyStyles,
    LayoutStyles,
    ReportStyles,
    localStyles
  ),
  withApollo
);
